import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import rootReducer from "./rootReducer";

import { applyCachePolicy } from "api/cachePolicy";
import { api } from "api/generated";

// Musí proběhnout před prvním renderem — mutuje definice endpointů, ze kterých pak
// generované hooky čtou. Sem, a ne do `App.tsx`: store je jediné místo, kterým projde
// každý vstup do aplikace včetně testů a Storybooku. `api` se předává, ne importuje
// v `cachePolicy` — důvod je v poznámce tam. [TD-362]
applyCachePolicy(api);

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
